<template>
  <div>
    <h4 v-if="limitSecond > 0">
      {{ "time_ower" | setText("Осталось секунд:") }} {{ limitSecond }}
    </h4>

    <div class="row">
      <div class="col-12 col-md-12">
        <fg-input
          :disabled="resend"
          :type="`number`"
          :label="`Код из смс`"
          :labelKey="`sms_code`"
          v-model.number="data.code"
        ></fg-input>
      </div>
    </div>

    <div v-if="!resend" class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
    <div v-else class="install-control">
      <button @click="reSend" class="btn btn-success">
        {{ "resend" | setText("Переотправить код") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {
    limitSecond(val) {
      if (val < 1) {
        this.resend = true;
      }
    },
  },
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {
    setInterval(() => {
      this.limitSecond--;
    }, 1000);
  },
  methods: {
    send() {
      this.$loading(true);
      let data = {};

      data["loan_id"] = this.transaction["exchange_id"];
      data["OTP_session"] = this.value["OTP_session"];
      data["OTP_code"] = this.data.code;

      this.$http({
        url: `${this.partner["endpoint_url"]}confirm-card-otp`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              step: "customer-data",
            });
            this.$emit("setStep", "customer-data");
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    reSend() {
      this.$loading(true);
      let data = {};
      data["loan_id"] = this.transaction["exchange_id"];

      this.$http({
        url: `${this.partner["endpoint_url"]}send-data/resend-sms`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            this.resend = false;
            this.limitSecond = 120;
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {
        code: null,
      },
      limitSecond: 120,
      resend: false,
    };
  },
};
</script>

